// Loading indicator: a pétanque boule that rolls. The etched surface grooves
// spin (so it reads as rolling metal) while the highlight stays fixed; pass
// `roll` to also roll it side to side (nice for full-page loads).
export default function PetanqueLoader({ size = 24, roll = false, className = '' }) {
  return (
    <span className={`inline-block ${roll ? 'boule-roll' : ''} ${className}`}
          style={{ lineHeight: 0 }} role="status" aria-label="Loading">
      <svg width={size} height={size} viewBox="0 0 24 24">
        <defs>
          <radialGradient id="boule-metal" cx="36%" cy="30%" r="72%">
            <stop offset="0%" stopColor="#F4F6F9" />
            <stop offset="45%" stopColor="#AEB4BE" />
            <stop offset="100%" stopColor="#565D68" />
          </radialGradient>
        </defs>
        {/* sphere (fixed light) */}
        <circle cx="12" cy="12" r="11" fill="url(#boule-metal)" stroke="#454B54" strokeWidth="0.5" />
        {/* rolling surface: etched grooves */}
        <g className="boule-surface" stroke="#6A717C" strokeWidth="0.9" fill="none" opacity="0.55">
          <path d="M2.5 9 A 11 11 0 0 1 21.5 9" />
          <path d="M1.6 12 A 11 11 0 0 1 22.4 12" />
          <path d="M2.5 15 A 11 11 0 0 1 21.5 15" />
          <path d="M9 2.5 A 11 11 0 0 1 9 21.5" />
          <path d="M15 2.5 A 11 11 0 0 1 15 21.5" />
        </g>
        {/* specular highlight (fixed) */}
        <ellipse cx="8.4" cy="8" rx="2.7" ry="1.9" fill="#FFFFFF" opacity="0.75" />
      </svg>
    </span>
  );
}
